module.exports = __webpack_public_path__ + "img/album_member@3x.0e6b34fe.png";